import { NgModule } from '@angular/core';
import { AvSpinnerComponent } from './spinner';

@NgModule({
  imports: [],
  exports: [ AvSpinnerComponent ],
  declarations: [ AvSpinnerComponent ],
  providers: [],
})
export class AvSpinnerModule { }
